import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.5.2_25fd19088376a98b76e0b248505c6efa/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}